import { render, staticRenderFns } from "./BudgetQuota.vue?vue&type=template&id=2cc96f34"
import script from "./BudgetQuota.vue?vue&type=script&lang=js"
export * from "./BudgetQuota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports